// @ts-nocheck
import { FC, useState } from 'react';
import { Button, Modal } from '@components/index';
import { TrashIcon } from '@icons/index';
import styles from './RemoveCardModal.module.scss';

interface IRemoveCardModalProps {
  showModal: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  cardNumber: string;
  expiryDate: string;
}

/**
 * @param showModal: boolean - a condition to render our modal
 * @param onCancel: function - a fn to call on modal cancelation
 * @param onConfirm: function - a fn to call on modal confirmation
 * @param cardNumber: string - card number of the card to help user identify the card is being deleted
 * @param expiryDate: string - expiry date of the card to help user identify the card is being deleted
 * @description a modal for Deleting user payment method.
 */
const RemoveCardModal: FC<IRemoveCardModalProps> = (props) => {
  const { showModal, onCancel, onConfirm, cardNumber, expiryDate } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
    onConfirm();
  };

  return (
    <Modal showModal={showModal}>
      <div className={styles.layout}>
        <div className={styles.trashIcon}>
          <TrashIcon stroke="#D92D20" />
        </div>
        <p className={styles.title}>Delete card</p>
        <p className={styles.description}>
          Are you sure you want to delete card ending in{' '}
          {cardNumber.replaceAll('*', '').trim()}, and expiry date
          {` ${expiryDate.split(' ')[1]}`}?
        </p>
        <div className={styles.actions}>
          <Button type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={handleSubmit}
            isLoading={isSubmitting}
            variant="danger"
          >
            Yes, delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveCardModal;
